module.exports = __webpack_public_path__ + "assets/images/c36916a4e2baa866094d71c686bb7bff.png";